var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checked_list" },
    [
      _c("div", { staticClass: "yxtbiz-area-selector__right_count" }, [
        _vm._v(
          _vm._s(
            _vm
              .$t("pc_biz_shoptour_select_info" /*已选择（{0}/{1}）*/, [
                _vm.list.length,
                _vm.limit,
              ])
              .d("已选择（" + _vm.list.length + "/" + _vm.limit + "）")
          )
        ),
      ]),
      _vm.list.length > 0
        ? _c("div", { staticClass: "checked_list_box" }, [
            _c(
              "div",
              { staticStyle: { height: "100%" } },
              [
                _c("yxtbiz-virtual-list", {
                  staticStyle: { height: "100%", overflow: "hidden" },
                  attrs: {
                    "is-scrollbar": "",
                    "data-sources": _vm.list,
                    "data-key": "id",
                    "estimate-size": 32,
                    keeps: 50,
                    "item-tag": "div",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var source = ref.source
                          return [
                            _c(
                              "yxt-tag",
                              {
                                key: source.id,
                                staticClass: "mb8 tag",
                                attrs: {
                                  "disable-transitions": "",
                                  size: "mini",
                                  type: "info",
                                  closable: "",
                                },
                                on: {
                                  close: function ($event) {
                                    return _vm.clear(source)
                                  },
                                },
                              },
                              [
                                _c("yxt-svg", {
                                  staticClass: "mr5 v-mid",
                                  attrs: {
                                    width: "14px",
                                    height: "14px",
                                    "icon-class": "dept",
                                  },
                                }),
                                _c("span", { staticClass: "tag_span" }, [
                                  _vm._v(" " + _vm._s(source.areaName)),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    831738441
                  ),
                }),
              ],
              1
            ),
          ])
        : _c("yxt-empty", {
            staticStyle: { position: "relative", top: "calc(50% - 133px)" },
          }),
      _c(
        "div",
        { staticClass: "operation" },
        [
          _c(
            "yxt-button",
            {
              staticClass: "font-size-14 color-gray-9 hover-primary-6",
              attrs: { type: "text", disabled: _vm.list.length === 0 },
              on: { click: _vm.clearAll },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("pc_biz_shoptour_clear_all").d("清除所有")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }